<template>
  <div
    class="switch-input"
    v-bind:class="{
      'switch-input--border': hasBorder,
      'switch-input--border-left': hasBorderLeft
    }"
    v-if="layoutPart === 'layer'"
  >
    <input
      type="checkbox"
      :id="layerId"
      :checked="layers.layers[layerId].isActive"
      @change="toggleLayer(layerId)"
    />
    <label :for="layerId">
      <span class="switch-input__body"></span>
      <span class="switch-input__handle"></span>
      <slot></slot>
    </label>
  </div>
  <div
    class="switch-input"
    v-bind:class="{
      'switch-input--border': hasBorder,
      'switch-input--border-left': hasBorderLeft
    }"
    v-else-if="layoutPart === 'cadastralInfo'"
  >
    <input
      type="checkbox"
      v-model="general.showCadastralLayer"
      id="cadastralLayer"
      @change="toggleCadastralLayer(!general.showCadastralLayer)"
    />
    <label for="cadastralLayer">
      <span class="switch-input__body"></span>
      <span class="switch-input__handle"></span>
      <slot></slot>
    </label>
  </div>
  <div class="switch-input" v-else-if="layoutPart === 'gps'">
    <input
      type="checkbox"
      v-model="general.enableGeolocation"
      id="gps"
      @change="toggleGeolocation(general.enableGeolocation)"
    />
    <label for="gps">
      <span class="switch-input__body"></span>
      <span class="switch-input__handle"></span>
      <slot></slot>
    </label>
  </div>
  <div
    class="switch-input"
    v-bind:class="{
      'switch-input--border': hasBorder,
      'switch-input--border-left': hasBorderLeft
    }"
    v-else
  >
    <input
      type="checkbox"
      :id="layoutPart"
      v-model="general.layout[layoutPart]"
      @change="changeLayoutOption(layoutPart, general.layout[layoutPart])"
    />
    <label :for="layoutPart">
      <span class="switch-input__body"></span>
      <span class="switch-input__handle"></span>
      <slot></slot>
    </label>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  props: {
    layoutPart: {
      type: String,
      required: true
    },
    hasBorder: {
      type: Boolean,
      required: false
    },
    hasBorderLeft: {
      type: Boolean,
      required: false
    },
    layerId: {
      type: [Number, String],
      required: false
    }
  },
  data() {
    return {
      dlayoutPart: this.layoutPart,
      dlayoutStatus: this.layoutStatus,
      dhasBorder: this.hasBorder,
      dlayerId: parseInt(this.layerId)
    };
  },
  computed: {
    ...mapState(['general', 'route', 'layers']),
    ...mapActions(['general/setLayoutOption', 'layers/toggleGmLayer'])
  },
  methods: {
    changeLayoutOption(part, status) {
      this.$store.dispatch('general/setLayoutOption', [part, status]);
    },
    toggleLayer(layerId) {
      this.$store.dispatch('layers/toggleGmLayer', layerId);
    },
    toggleCadastralLayer(status) {
      this.$store.dispatch('general/setShowCadastralLayer', status);
    },
    toggleGeolocation(status) {
      this.$store.dispatch('general/setEnableGeolocation', status);
    }
  }
};
</script>

<style scoped>
.switch-input--border {
  border-right: 1px solid rgb(204, 204, 204);
  margin-right: 10px;
  padding-right: 10px;
}

.switch-input--border-left {
  border-left: 1px solid rgb(204, 204, 204);
  margin-left: 10px;
  padding-left: 10px;
}

.switch-input {
  display: inline-block;
}

.switch-input input[type='checkbox'] {
  height: 0;
  width: 0;
  visibility: hidden;
  position: absolute;
}

.switch-input label {
  cursor: pointer;
  position: relative;
  padding-left: 45px;
  text-shadow: 0px 0px 4px #fff;
}

.switch-input .switch-input__body {
  content: '';
  display: inline-block;
  width: 38px;
  height: 19px;
  background: grey;
  display: block;
  border-radius: 100px;
  position: absolute;
  top: 0;
  left: 0;
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
}

.switch-input .switch-input__handle {
  content: 'x';
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  position: absolute;
  left: 3px;
  top: 2px;

  background: #fff;
  box-shadow: 0 0 4px #888;
  transition: all 0.3s cubic-bezier(0.19, 1, 0.22, 1);
}

input:checked + label .switch-input__handle {
  left: 20px;
}

input:checked + label .switch-input__body {
  background-color: #bada55;
}
</style>
